module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch6_20210921134151_T.5398b346.jpg";